/** Calendar date → UTC midnight ISO with Z, e.g. 2026-06-15T00:00:00.000Z (no timezone shift). */
export const toIsoDateTimeString = (value: string): string => {
  const trimmed = value.trim()
  if (!trimmed) return ''

  const dateMatch = trimmed.match(/^(\d{4}-\d{2}-\d{2})/)
  if (!dateMatch) return trimmed

  return `${dateMatch[1]}T00:00:00.000Z`
}

/** ISO stored value → YYYY-MM-DD for date picker display (keeps selected calendar day). */
export const fromIsoDateTimeForDatePicker = (value: string): string => {
  const trimmed = value.trim()
  if (!trimmed) return ''

  const dateMatch = trimmed.match(/^(\d{4}-\d{2}-\d{2})/)
  return dateMatch ? dateMatch[1] : trimmed
}
